module.exports = __webpack_public_path__ + "assets/img/default-news.4635ca1c.jpg";